/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type { DownloadCollection } from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class DownloadApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service stellt für das Frontend Metadaten bereit welche Dokumente für den Kunden abrufbar sind.
 * @summary Stelle Liste der abrufbaren Dokumente bereit
 */
 getDownloads<TData = DownloadCollection>( options?: HttpClientBodyOptions): Observable<TData>;
 getDownloads<TData = DownloadCollection>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getDownloads<TData = DownloadCollection>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getDownloads<TData = DownloadCollection>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/downloads`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/downloads`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/downloads`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Abrufen von PDF-Dokumenten anhand deren UUID. Das Mapping der UUIDs zu den PDF-Dokumenten ist backendseitig festgelegt.
 * @summary Rufe PDF-Datei anhand deren UUID ab
 */
 getDownload(fileId: string, options?: HttpClientBodyOptions): Observable<Blob>;
 getDownload(fileId: string, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getDownload(fileId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getDownload(
    fileId: string, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/downloads/${fileId}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/downloads/${fileId}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/downloads/${fileId}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }
};

